import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useEditTemplateDialogStyles = makeStyles({
  dialogSurface: {
    maxWidth: "600px",
    maxHeight: "80vh",
  },
  dialogContent: {
    minHeight: "480px",
    maxHeight: "calc(80vh - 120px)",
  },

  knowledgeComponentCombobox: {
    maxWidth: "420px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },

  comboboxOption: {
    color: designTokens.neutral[700],
  },

  knowledgeComponentsGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
  },

  allowedUsersHelp: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    marginTop: designTokens.spacing[2],
  },

  textareaField: {
    "& textarea": {
      resize: "vertical",
    },
  },

  iconDropdownValue: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
});
